import React, {useCallback, useEffect, useState} from 'react';
import {
  DataGrid
} from "@mui/x-data-grid";
import _uniqueId from "lodash/uniqueId";
import { Grid } from "@mui/material";
import {getData} from "../util/__fetch";


const COLUMNS = [
  { field: 'user', headerName: 'User', width: 120, type: 'string', },
  { field: 'broker', headerName: 'Broker', width: 120, type: 'string', },
  {
    field: 'tradingSymbol',
    headerName: 'Symbol',
    width: 200,
    type: 'string',
    valueGetter: (params) => params.row?.position?.tradingsymbol
  },
  {
    field: 'position?.expirydate',
    headerName: 'Expiry',
    width: 100,
    type: 'string',
    valueGetter: (params) => params.row?.position?.expirydate
  },
  {
    field: 'position?.buyamount',
    headerName: 'Buy Amount',
    width: 120,
    type: 'number',
    valueGetter: (params) => params.row?.position?.buyamount
  },
  {
    field: 'position?.buyqty',
    headerName: 'Buy Qty',
    width: 80,
    type: 'number',
    valueGetter: (params) => params.row?.position?.buyqty
  },
  {
    field: 'position?.sellamount',
    headerName: 'Sell Amount',
    width: 120,
    type: 'number',
    valueGetter: (params) => params.row?.position?.sellamount
  },
  {
    field: 'position?.sellqty',
    headerName: 'Sell Qty',
    width: 80,
    type: 'number',
    valueGetter: (params) => params.row?.position?.sellqty
  },
  {
    field: 'position?.netqty',
    headerName: 'Net Qty',
    width: 80,
    type: 'number',
    valueGetter: (params) => params.row?.position?.netqty
  },
  {
    field: 'pnl',
    headerName: 'P&L',
    width: 80,
    type: 'number',
    valueGetter: (params) => params.row?.position?.pnl
  },
]
const AllPositions = ({user, allPositions, setAllPositions, customToolBar, getClassName, refreshPositions }) => {
  const [positions, setPositions] = useState([])

  const loadPositions = useCallback(() => {
    getData('/algo-trading/api/publish/positions', user, setAllPositions, (() => {}), (() => {}))
      .then(response => { /* ignore */});
  }, [user, refreshPositions]);

  useEffect(() => {
    const interval = setInterval(() => {
      loadPositions()
    }, 25000);
    loadPositions();
    return () => clearInterval(interval);
  }, [user, loadPositions]);

  useEffect(() => {
    const onlyOpenFNOPositions = allPositions
      .filter(data => data?.position?.netqty !== 0)
      .filter(data => data?.position?.exchange === 'NFO' || data?.position?.exchange === 'BFO');
    // console.log('open positions', onlyOpenFNOPositions)
    setPositions(onlyOpenFNOPositions);
  }, [allPositions]);


  return (
    <Grid item>
      <DataGrid
        key={"2"}
        getRowId={(row) => row?.tradingsymbol + _uniqueId()}
        columns={COLUMNS}
        rows={positions}
        autoHeight={true}
        initialState={{
          sorting: {
            sortModel: [{ field: 'user', sort: 'asc' }]
          },
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        pageSizeOptions={[50, 100, 200, 500]}
        slots={{
          toolbar: () => customToolBar('Open Positions'),
        }}
        getCellClassName={(params) => {
          if (params.field !== 'pnl') {
            return '';
          }
          return getClassName(params, 'pnl')
        }}
      />
    </Grid>
  )
}

export default AllPositions;